import React from 'react';
import classNames from 'classnames';
import AccordionButton from './AccordionButton';

type Level = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

export interface AccordionHeadingProps {
  /**
   * Use the accurate heading level to maintain the document outline.
   */
  as?: Level;
  children?: React.ReactNode;
  className?: string;
  id?: string;
  /**
   * The Accordion Content's id that this heading controls
   */
  controls: string;
}

const AccordionHeading = ({
  as: Component = 'h2',
  controls,
  children,
  className,
  id,
}: AccordionHeadingProps): JSX.Element => {
  return (
    <Component id={id} className={classNames(className, 'usa-accordion__heading')}>
      <AccordionButton controls={controls}>{children}</AccordionButton>
    </Component>
  );
};

export default AccordionHeading;
